import _typeof from '@babel/runtime/helpers/typeof';
import classnames from 'classnames';
import React__default from 'react';
import { usePagination } from './Pagination/utils/hooks.js';
import SelectionCell from './RowSelection/SelectionCell.js';

var generateRow = function generateRow(singleRowData, columnOrder, columnRowHeader, classesForColumns, showGrid) {
  return columnOrder.map(function (key) {
    var classesForBodyCell = classnames('C-TableAdvanced__bodyCell', {
      '--showGrid': showGrid
    }, classesForColumns[key]);
    if (singleRowData[key] !== undefined) {
      if (_typeof(singleRowData[key]) === ('date' )) {
        console.error('Hey Canvas User, looks like you passed a special data type as a field value. Please pass a cell object with `cellDisplay` and `cellValue` attributes instead.');
      }
      if (_typeof(singleRowData[key]) === 'object') {
        var _singleRowData$key, _singleRowData$key2;
        return /*#__PURE__*/React__default.createElement("td", {
          "data-value": String((_singleRowData$key = singleRowData[key]) === null || _singleRowData$key === void 0 ? void 0 : _singleRowData$key.cellValue),
          className: classesForBodyCell,
          key: "".concat(key, "-data")
        }, (_singleRowData$key2 = singleRowData[key]) === null || _singleRowData$key2 === void 0 ? void 0 : _singleRowData$key2.cellDisplay);
      } else {
        return /*#__PURE__*/React__default.createElement("td", {
          className: classesForBodyCell,
          role: columnRowHeader === key ? 'rowheader' : null,
          key: "".concat(key, "-data")
        }, singleRowData[key]);
      }
    } else {
      return /*#__PURE__*/React__default.createElement("td", {
        className: classesForBodyCell,
        key: "".concat(key, "-data")
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "hc-sr-only",
        "aria-label": "empty cell"
      }, "N/A"));
    }
  });
};
var Rows = function Rows(_ref) {
  var displayData = _ref.displayData,
    dataTestId = _ref.dataTestId,
    columnOrder = _ref.columnOrder,
    columnRowHeader = _ref.columnRowHeader,
    classesForColumns = _ref.classesForColumns,
    onRowSelect = _ref.onRowSelect,
    rowSelection = _ref.rowSelection,
    selectedRows = _ref.selectedRows,
    showGrid = _ref.showGrid,
    tableName = _ref.tableName;
  var _usePagination = usePagination(),
    _usePagination$state = _usePagination.state,
    isClient = _usePagination$state.isClient,
    itemRange = _usePagination$state.itemRange;
  var rowData = isClient ? displayData.slice(itemRange.start - 1, itemRange.end) : displayData;
  return rowData.map(function (singleRowData, index) {
    return /*#__PURE__*/React__default.createElement("tr", {
      className: "C-TableAdvanced__bodyRow",
      key: "row-".concat(index)
    }, rowSelection && /*#__PURE__*/React__default.createElement(SelectionCell, {
      dataTestId: dataTestId,
      onRowSelect: onRowSelect,
      rowId: singleRowData.id,
      rowSelection: rowSelection,
      selectedRows: selectedRows,
      tableName: tableName
    }), generateRow(singleRowData, columnOrder, columnRowHeader, classesForColumns, showGrid));
  });
};

export { Rows as default };
